var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { getBexApiContext } from 'bernie-context';
import { NOOP_LOGGER } from 'bernie-logger';
import { Store } from 'bernie-plugin-mobx';
import * as cookies from 'browser-cookies';
import { computed, observable } from 'mobx';
import { ActivitySearchViewOptions, ActivitySort } from '../common/__generated__/api/types';
import { equals, getFilteredObjectKeys } from '../helpers/common-helper';
import { activityDateRangeInput } from '../helpers/controller-date-helper';
import { getIsoFormatDateFromDateString } from '../helpers/date-helper';
import { LandingPageType } from '../utils/geoLocation';
/* eslint-disable @typescript-eslint/no-var-requires  */
/* eslint-disable class-methods-use-this  */
var xss = require('xss');
var DEFAULT_ACTIVITIES_LENGTH = 50;
var NUM_OF_DAYS_BOOKABLE_IN_ADVANCE = 328;
var PAGINATION_START_INDEX = 0;
var MCTC_MOD_ENABLED = 2;
var GROUND_TRANSFER_BANNER_COOKIE = 'ground_transfer_banner_shown';
export var FILTER_URL_PARAM_PREFIX = 'filter.';
var SearchCriteriaStore = /** @class */function (_super) {
  __extends(SearchCriteriaStore, _super);
  function SearchCriteriaStore(state, logger, appConfig, marketingInfo) {
    if (state === void 0) {
      state = {};
    }
    if (logger === void 0) {
      logger = NOOP_LOGGER;
    }
    var _this = _super.call(this, state, logger) || this;
    _this.isQueryStringUpdated = true;
    _this.searchQuery = {};
    _this.pillRemoveIndex = null;
    _this.numOfDaysBookableInAdvance = NUM_OF_DAYS_BOOKABLE_IN_ADVANCE;
    _this.activityToFocus = {
      index: null,
      element: null
    };
    _this.defaultActivitiesLength = DEFAULT_ACTIVITIES_LENGTH; // Should only be set in the controller
    _this.paginationIndex = PAGINATION_START_INDEX;
    _this.experimentStore = null;
    if (appConfig) {
      _this.firstLoadActivityCount = appConfig.firstLoadActivityCount;
    }
    _this.searchQuery = {};
    _this.scrollPosition = 0;
    _this.activityToFocus.element = null;
    _this.activityToFocus.index = null;
    if (marketingInfo) {
      _this.marketingInfo = marketingInfo;
    }
    return _this;
  }
  SearchCriteriaStore.prototype.setContext = function (context) {
    this.context = getBexApiContext(context);
  };
  Object.defineProperty(SearchCriteriaStore.prototype, "currentSearchVariables", {
    // this getter is useful for non-reactive context like controllers, sync functions, for other cases like components
    // please use the searchVariables getter instead because @computed contains performance improvements
    get: function () {
      if (this.context && this.localDateFormat) {
        return {
          context: this.context,
          destination: this.activityDestinationInput,
          dateRange: activityDateRangeInput(this.searchQuery, this.localDateFormat),
          filters: this.activitySearchFiltersInput,
          sort: this.activitySort,
          pagination: this.pagination,
          marketing: this.marketing,
          searchViewOptions: this.searchViewOptions
        };
      }
      return null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "searchVariables", {
    get: function () {
      return this.currentSearchVariables;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "getPaginationIndex", {
    get: function () {
      return this.paginationIndex;
    },
    enumerable: false,
    configurable: true
  });
  SearchCriteriaStore.prototype.hydrate = function (data) {
    this.searchQuery = __assign({}, data.searchQuery);
    this.context = __assign({}, data.context);
    this.isQueryStringUpdated = data.queryStringUpdated;
    this.localDateFormat = data.localDateFormat;
    this.firstLoadActivityCount = data.firstLoadActivityCount;
    this.scrollPosition = 0;
    this.activityToFocus.index = null;
    this.activityToFocus.element = null;
    this.marketingInfo = data.marketingInfo;
    delete data.marketingInfo;
  };
  SearchCriteriaStore.prototype.getFilterSpecificKeysFromQueryObjects = function (queries) {
    var combinedQueryObj = {};
    queries.forEach(function (query) {
      combinedQueryObj = __assign(__assign({}, combinedQueryObj), query);
    });
    return getFilteredObjectKeys(combinedQueryObj, FILTER_URL_PARAM_PREFIX);
  };
  SearchCriteriaStore.prototype.isQueryKeysDifferent = function (query) {
    var _this = this;
    var searchKeys = __spreadArray(['location', 'endDate', 'startDate', 'sort', 'swp', 'slimSearchKeyword', 'rid', 'selectedId', 'mctc', 'travelDurationFromHotelEnabled', 'regionType', 'latLong', 'landingPage'], __read(this.getFilterSpecificKeysFromQueryObjects([query, this.searchQuery])), false);
    return searchKeys.some(function (key) {
      if (_this.localDateFormat && key && _this.searchQuery[key] && (key === 'startDate' || key === 'endDate')) {
        return !equals(getIsoFormatDateFromDateString(query[key], _this.localDateFormat), getIsoFormatDateFromDateString(_this.searchQuery[key] || '', _this.localDateFormat));
      }
      return !equals(query[key], _this.searchQuery[key]);
    });
  };
  SearchCriteriaStore.prototype.hasLocation = function (query) {
    return query.location !== undefined && query.location !== '';
  };
  SearchCriteriaStore.prototype.resetPaginationIndex = function () {
    this.paginationIndex = 0;
  };
  SearchCriteriaStore.prototype.showMore = function () {
    this.paginationIndex += 1;
  };
  SearchCriteriaStore.prototype.resetSearchCriteriaStore = function () {
    this.resetPaginationIndex();
    this.isQueryStringUpdated = true;
    this.scrollPosition = 0;
    this.activityToFocus.index = null;
    this.activityToFocus.element = null;
  };
  SearchCriteriaStore.prototype.populateDefaultSortIfApplicable = function () {
    if (this.searchQuery && !this.searchQuery.sort) {
      this.searchQuery = __assign(__assign({}, this.searchQuery), {
        sort: ActivitySort.RECOMMENDED.valueOf()
      });
    }
  };
  SearchCriteriaStore.prototype.populateRegionTypeForLandingPage = function (query) {
    if (query && query.landingPage) {
      query.regionType = query.landingPage;
      if (this.searchQuery) {
        this.searchQuery = __assign(__assign({}, this.searchQuery), {
          regionType: query.regionType
        });
      }
    }
  };
  SearchCriteriaStore.prototype.setExperimentStore = function (experimentStore) {
    this.experimentStore = experimentStore;
  };
  SearchCriteriaStore.prototype.getExperimentStore = function () {
    return this.experimentStore;
  };
  SearchCriteriaStore.prototype.setGroundTransfersBannerCookie = function () {
    if (typeof document !== 'undefined' && document.cookie) {
      var isCookieSet = cookies.get(GROUND_TRANSFER_BANNER_COOKIE);
      if (!isCookieSet) {
        cookies.set(GROUND_TRANSFER_BANNER_COOKIE, 'true');
      }
    }
  };
  Object.defineProperty(SearchCriteriaStore.prototype, "marketing", {
    get: function () {
      var marketingInfo = {};
      if (this.marketingInfo) {
        marketingInfo.sem = this.marketingInfo.sem;
        marketingInfo.semdtl = this.marketingInfo.semdtl;
      }
      if (this.lxModEnabled) {
        marketingInfo.mctc = MCTC_MOD_ENABLED;
      }
      return marketingInfo;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "lxModEnabled", {
    get: function () {
      var mctcIsSet = this.searchQuery.mctc ? this.searchQuery.mctc === MCTC_MOD_ENABLED.toString() : false;
      return mctcIsSet || typeof document !== 'undefined' && document.cookie.includes('lx_mod_enabled=true');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "pagination", {
    get: function () {
      var pagination = {};
      pagination.size = this.defaultActivitiesLength;
      pagination.startingIndex = this.paginationIndex;
      return pagination;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "activityDestinationInput", {
    get: function () {
      var latLongArray = this.searchQuery.latLong ? this.searchQuery.latLong.split(',') : null;
      var latLong = latLongArray && latLongArray.length > 1 ? {
        latitude: parseFloat(latLongArray[0]),
        longitude: parseFloat(latLongArray[1])
      } : null;
      return {
        regionName: this.sanitizeInput(this.searchQuery.location),
        pinnedActivityId: this.searchQuery.selectedId,
        regionId: this.searchQuery.rid,
        regionType: this.searchQuery.regionType,
        coordinates: latLong
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "activitySearchFiltersInput", {
    get: function () {
      if (!this.searchQuery) {
        return null;
      }
      var selections = this.getSearchCriteriaSelection();
      return {
        selections: selections
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "activitySort", {
    get: function () {
      return this.searchQuery.sort ? ActivitySort[this.searchQuery.sort] : null;
    },
    enumerable: false,
    configurable: true
  });
  SearchCriteriaStore.prototype.getSearchCriteriaSelection = function () {
    var _this = this;
    var selections = [];
    var filtersKeys = getFilteredObjectKeys(this.searchQuery, FILTER_URL_PARAM_PREFIX);
    var keyword = this.sanitizeInput(this.searchQuery.slimSearchKeyword);
    selections.push({
      id: 'sort',
      value: this.searchQuery.sort ? this.searchQuery.sort : ActivitySort.RECOMMENDED.valueOf()
    });
    if (keyword && keyword.length > 0) {
      selections.push({
        id: 'slimSearchKeyword',
        value: keyword
      });
    }
    filtersKeys.forEach(function (filtersKey) {
      var filterId = filtersKey.split('.')[1];
      if (_this.searchQuery[filtersKey]) {
        var filterVals = _this.searchQuery[filtersKey].split(',');
        filterVals.forEach(function (filterVal) {
          if (filterVal && filterVal !== '') {
            selections.push({
              id: filterId,
              value: filterVal
            });
          }
        });
      }
    });
    return selections;
  };
  Object.defineProperty(SearchCriteriaStore.prototype, "showGroundTransfersBanner", {
    get: function () {
      if (typeof document !== 'undefined' && document.cookie) {
        return !cookies.get(GROUND_TRANSFER_BANNER_COOKIE);
      }
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SearchCriteriaStore.prototype, "searchViewOptions", {
    get: function () {
      var searchViewOptions = [];
      if (this.searchQuery.travelDurationFromHotelEnabled === 'true') {
        searchViewOptions.push(ActivitySearchViewOptions.TRAVEL_DISTANCE_FROM_HOTEL);
      }
      // Use off as default is on. Open to suggestion here.
      if (this.searchQuery.swp !== 'off') {
        searchViewOptions.push(ActivitySearchViewOptions.SHOP_WITH_POINTS);
      }
      if (this.searchQuery.regionType === LandingPageType.LOCAL || this.searchQuery.regionType === LandingPageType.ULTRA_LOCAL) {
        searchViewOptions.push(ActivitySearchViewOptions.NEARBY_ACTIVITIES);
      }
      if (this.showGroundTransfersBanner) {
        searchViewOptions.push(ActivitySearchViewOptions.SHOW_GT_BANNER);
      }
      return searchViewOptions.length > 0 ? searchViewOptions : null;
    },
    enumerable: false,
    configurable: true
  });
  SearchCriteriaStore.prototype.isDateOrLocationChanged = function (query) {
    var _this = this;
    var searchKeys = ['location', 'endDate', 'startDate'];
    return searchKeys.some(function (key) {
      if ((key === 'startDate' || key === 'endDate') && _this.localDateFormat && _this.searchQuery[key]) {
        return !equals(getIsoFormatDateFromDateString(query[key], _this.localDateFormat), getIsoFormatDateFromDateString(_this.searchQuery[key], _this.localDateFormat));
      }
      return _this.searchQuery[key] && !equals(query[key], _this.searchQuery[key]);
    });
  };
  SearchCriteriaStore.prototype.isSortOrFilterChanged = function (query) {
    return !equals(this.searchQuery.sort, query.sort) || !equals(this.searchQuery['filter.categories'], query['filter.categories']);
  };
  SearchCriteriaStore.prototype.isSortOrFilterUpdated = function (query) {
    var sortChanged = !equals(ActivitySort.RECOMMENDED, query.sort);
    var filterChanged = Object.keys(query).find(function (key) {
      return key.includes(FILTER_URL_PARAM_PREFIX) && query[key];
    }) !== undefined;
    return sortChanged || filterChanged;
  };
  SearchCriteriaStore.prototype.resetQueryObject = function (query) {
    var searchResetKeys = __spreadArray(['sort', 'slimSearchKeyword', 'selectedId', 'rid', 'regionType', 'srpOpen'], __read(this.getFilterSpecificKeysFromQueryObjects([query])), false);
    searchResetKeys.forEach(function (key) {
      query[key] = '';
    });
    if (this.searchQuery.location && !equals(this.searchQuery.location, query.location)) {
      delete query.latLong;
      delete query.travelDurationFromHotelEnabled;
    }
  };
  SearchCriteriaStore.prototype.sanitizeInput = function (input) {
    var xssOptions = {
      stripIgnoreTag: true,
      whiteList: {}
    };
    return xss(input, xssOptions);
  };
  __decorate([observable], SearchCriteriaStore.prototype, "isQueryStringUpdated", void 0);
  __decorate([observable], SearchCriteriaStore.prototype, "searchQuery", void 0);
  __decorate([computed], SearchCriteriaStore.prototype, "searchVariables", null);
  return SearchCriteriaStore;
}(Store);
export { SearchCriteriaStore };